import { createAction } from '@reduxjs/toolkit';

export const setStateFilter = createAction<string>('USE_CASE_PAGE/SET_STATE_FILTER');
export const setCustomerFilter = createAction<string>('USE_CASE_PAGE/SET_CUSTOMER_FILTER');
export const setPlatformFilter = createAction<string>('USE_CASE_PAGE/SET_PLATFORM_FILTER');
export const setOutcomeFilter = createAction<string>('USE_CASE_PAGE/SET_OUTCOME_FILTER');

export const expandCategory = createAction<string>('USE_CASE_PAGE/EXPAND_CATEGORY');
export const collapseCategory = createAction<string>('USE_CASE_PAGE/COLLAPSE_CATEGORY');
export const clearExpandedCategories = createAction('USE_CASE_PAGE/CLEAN_EXPANDED_CATEGORIES');

export const selectCustomerOutcome = createAction<string>('USE_CASE_PAGE/SELECT_CUSTOMER_OUTCOME');
